import {cn} from '../../lib/utils';
import {BackButton} from '../BackButton';
import {ForwardButton} from '../ForwardButton';

import type {FC, ReactNode} from 'react';

export interface BreadcrumbsRowBack {
  onClick: () => void;
  ariaLabel: string;
  disabled?: boolean;
}

export type BreadcrumbsRowForward = BreadcrumbsRowBack;

export interface BreadcrumbsRowProps {
  back?: BreadcrumbsRowBack;
  forward?: BreadcrumbsRowForward;
  className?: string;
  children: ReactNode;
}

export const BreadcrumbsRow: FC<BreadcrumbsRowProps> = ({back, forward, className, children}) => (
  <div className={cn('flex items-center gap-2', className)}>
    {back && (
      <BackButton onClick={back.onClick} ariaLabel={back.ariaLabel} disabled={back.disabled} />
    )}
    {forward && (
      <ForwardButton
        onClick={forward.onClick}
        ariaLabel={forward.ariaLabel}
        disabled={forward.disabled}
      />
    )}
    {children}
  </div>
);
